import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("yagnika_admin_token");
      if (!token) {
        setReady(true);
        return;
      }
      try {
        const me = await adminMe();
        setUser(me);
      } catch {
        localStorage.removeItem("yagnika_admin_token");
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = (token, u) => {
    localStorage.setItem("yagnika_admin_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("yagnika_admin_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
